import { render, staticRenderFns } from "./TFPricing.vue?vue&type=template&id=536d859c&scoped=true&"
import script from "./TFPricing.vue?vue&type=script&lang=js&"
export * from "./TFPricing.vue?vue&type=script&lang=js&"
import style0 from "./TFPricing.vue?vue&type=style&index=0&id=536d859c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d859c",
  null
  
)

export default component.exports